import { ButtonVariant } from './../form/nicky-button/nicky-button.component';
import { Component, Input, Output, EventEmitter } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { NickyButtonComponent } from '../form/nicky-button/nicky-button.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-settings-header',
  imports: [TranslateModule, MatIconModule, NickyButtonComponent, CommonModule],
  templateUrl: './settings-header.component.html',
})
export class SettingsHeaderComponent {
  @Input() headerTitle = '';
  @Input() subtitle = '';
  @Input() showTourIcon = false;
  @Input() showHeaderButton = false;
  @Input() isHeaderButtonDisabled = false;
  @Input() buttonText: string | undefined = 'PROFILE.save';
  @Input() buttonIcon: string | undefined = undefined;
  @Input() ButtonVariant: ButtonVariant = 'primary';
  @Input() mobileWrap: boolean = false;

  @Output() onSave = new EventEmitter<void>();
  @Output() onTour = new EventEmitter<void>();
}
